import { render, staticRenderFns } from "./LecturePagesCreate.vue?vue&type=template&id=4ab92dd7&"
import script from "./LecturePagesCreate.vue?vue&type=script&lang=ts&"
export * from "./LecturePagesCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports